import React from "react";

// Icône "couple" — deux anneaux qui se chevauchent, extraite de Profile.tsx (où elle était
// définie à côté du champ "Statut marital") pour être réutilisée telle quelle sur le bouton
// Like d'un profil visité lorsque relationship gate est actif (voir hooks/useDateState.ts).
export default function RingsIcon({ size = 17 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="8.5" cy="13.5" r="5.5" /><circle cx="15.5" cy="13.5" r="5.5" />
    </svg>
  );
}
